import { useState } from "react";
import { toast } from "sonner";
import { Key } from "@phosphor-icons/react";
import { api, formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPassword, new_password: newPassword });
      toast.success("Password changed successfully");
      setOpen(false);
      setOldPassword("");
      setNewPassword("");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="change-password-button" variant="ghost" size="sm" className="w-full mt-2 text-xs justify-start px-2">
          <Key size={14} className="mr-1.5" /> Change Password
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>Change Password</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label>Current Password</Label>
            <Input data-testid="old-password-input" type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label>New Password (min 6 characters)</Label>
            <Input data-testid="new-password-input" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
          </div>
          <Button data-testid="change-password-submit" className="w-full" disabled={!oldPassword || newPassword.length < 6 || busy} onClick={submit}>
            {busy ? "Changing..." : "Change Password"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
